import {useEffect, useState} from "react";
import {collection, getDocs, getFirestore, onSnapshot, query} from "firebase/firestore";
import {BiSearch} from "react-icons/bi";
import { Table } from "react-bootstrap";
import CelebDetails from "./components/celebDetails";
import CelebrityTabCelebrityRow from "./components/celebrityRow";
import { getFunctions, httpsCallable } from "firebase/functions";
import axios from "axios";
import swal from "sweetalert";

export default function Celebs(){

    const [celebs,setCelebs]= useState([]);
    const [celebIds,setCelebIds]= useState([]);
    const [search,setSearch]= useState("");
    const [seeDetails,setSeeDetails]= useState(false);
    const [currentCelebDetailsId,setCurrentCelebDetailsId]=useState("");
    const db=getFirestore();
    const functions=getFunctions();



    const handleSearchChange=(e)=>{
        setSearch(e.target.value.trim());
        console.log(e.target.value);
    }



    useEffect(
        async()=>{
            const q = query(collection(db, "celebrities"));
            const unsubscribe = onSnapshot(q, (querySnapshot) => {
                const tempList = [];
                const tempIdList = [];

                querySnapshot.forEach((doc) => {
                    let data=doc.data();

                    if
                    (
                        data["fullName"].toString().toLowerCase().includes(search.trim().toLowerCase()) ||
                        data["email"].toString().toLowerCase().includes(search.trim().toLowerCase()) ||
                        data["phone"].toString().toLowerCase().includes(search.trim().toLowerCase()) ||
                        doc.id.toString().toLowerCase().includes(search.trim().toLowerCase())

                        )
                    {
                        tempList.push(doc.data());
                        tempIdList.push(doc.id);
                    }
                    else
                    {

                    }

                });

                setCelebs([...tempList])
                setCelebIds([...tempIdList]);
                
              
            });

            return function(){
                unsubscribe();
            };
        },
        [search,seeDetails]
    );


    const handleSeeCelebDetails=(celebIndex)=>{
        console.log(celebIndex);
        setCurrentCelebDetailsId(celebIds[celebIndex]);
        setSeeDetails(true);
    }

    const closeDialog=()=>{
        setSeeDetails(false);
        console.log('closed');
    }


    return(
        <div className="relative bg-transparent w-full h-full">
            {seeDetails===true?<CelebDetails closeButton={()=>closeDialog()} id={currentCelebDetailsId} />:<div className="z-10 absolute"/>}

            <div className="absolute h-full w-full p-10 flex justify-start items-start flex-col">
            <div className="text-white font-bold rounded-sm text-3xl mb-5">Celebrities</div>

            <div className="flex flex-row w-full items-center justify-between">
                <div className="flex flex-row w-2/4 bg-white mb-10 ">
                <input
                    onChange={(e)=>{handleSearchChange(e)}}
                    placeholder="Search"
                    className="w-11/12 p-3 text-black bg-white border-0 outline-0 shadow-xl"/>

                <div className="w-1/12 flex justify-center items-center">
                    <BiSearch size={40} color={"black"}/>
                </div>
                </div>
                <div className="h-20  font-bold text-md">
                    <button
                    onClick={async()=>{
                        swal("Send Notifications","Kindly Enter Message to send to the Celebs.",{content:"input"}).then(async(msg)=>{
                            const ref= await getDocs(collection(db,"celebrities"))
                            ref.docs.forEach((doc)=>{
                                const addMessage = httpsCallable(functions, 'manuallySendToCeleb');
                                addMessage({"user":doc.id,"message":msg})
                                axios.get(`https://us-central1-funnel-887b0.cloudfunctions.net/manuallySendToCeleb?user=${doc.id}&message=${msg}`);
                            })
                        });
                        
                    }}
                    className="font-bold bg-red-500 p-3 rounded-md" >Send Notification To All</button>
                </div>
            </div>

            <div className="w-full">
                <Table striped bordered hover className="text-white table-fixed">

                    <thead>
                        <tr className="w-full">
                            <th>
                                <div className="flex justify-center">
                                    Image
                                </div>
                            </th>
                            <th>
                                <div className="flex justify-center">
                                    Name
                                </div>
                            </th>
                            <th>
                                <div className="flex justify-center">
                                    Contact
                                </div>
                            </th>
                            <th>
                                <div className="flex justify-center">
                                    Country
                                </div>
                            </th>
                            <th>
                                <div className="flex justify-center">
                                    Date of Birth
                                </div>
                            </th>
                        
                            <th>
                                <div className="flex justify-center">
                                    Copy Id
                                </div>
                            </th>
                            <th>
                                <div className="flex justify-center">
                                    View Details
                                </div>
                            </th>
                        </tr>
                    </thead>



                    <tbody>
                    {
                        celebs.map(
                            (celebData,celebIndex)=>{
                                return(
                                    <CelebrityTabCelebrityRow
                                    seeUserInfo={()=>{handleSeeCelebDetails(celebIndex);}}
                                    key={celebIndex}
                                    id={celebIds[celebIndex]}
                                    celebData={celebData} />
                                )
                            }
                        )
                    }
                    </tbody>


                </Table>
            </div>

            

            </div> 
                
        </div>
    )
}